module.exports = __webpack_public_path__ + "static/img/92070B_1_R_20200819_LC.6e6afd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92070B_1_R_20200819_LC.png
// module id = BP6W
// module chunks = 0